import { cloneElement } from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  Filter,
  TopToolbar,
  useRecordContext,
  useGetOne,
} from "react-admin";

const ShipmentFilters = (props: any) => (
  <Filter {...props}>
    <TextInput key="trackingCode" label="Código de Rastreamento" source="trackingCode" alwaysOn />
    <TextInput key="plugNumber" label="Número do Plug" source="plugNumber" />
    <ReferenceInput key="productId" source="productId" reference="products" label="Produto">
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput key="licenseId" source="licenseId" reference="licenses" label="Licença">
      <AutocompleteInput optionText="serialNumber" />
    </ReferenceInput>
  </Filter>
);

const ShipmentListActions = (props: any) => (
  <TopToolbar>
    {cloneElement(props.filters, { context: "button" })}
  </TopToolbar>
);

const ShipmentUserDataField = ({ field, label: _label }: { field: "name" | "registration"; label?: string }) => {
  const shipment = useRecordContext<any>();
  const licenseId = shipment?.licenseId ?? shipment?.license_id ?? shipment?.license?.id;

  const { data: license, isLoading: isLoadingLicense } = useGetOne(
    "licenses",
    { id: licenseId },
    { enabled: !!licenseId }
  );

  const fallbackName =
    license?.user?.name ||
    shipment?.user?.name ||
    shipment?.userName ||
    "";
  const fallbackRegistration =
    license?.user?.registration ||
    shipment?.user?.registration ||
    shipment?.registration ||
    "";

  if (isLoadingLicense) {
    return <span>Carregando...</span>;
  }

  if (field === "name") {
    return <span>{fallbackName}</span>;
  }

  return <span>{fallbackRegistration}</span>;
};

export const ShipmentList = () => (
  <List
    actions={<ShipmentListActions />}
    filters={<ShipmentFilters />}
    perPage={25}
    sort={{ field: "createdAt", order: "DESC" }}
    empty={false}
  >
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" />
      <ShipmentUserDataField field="name" label="Usuário" />
      <ShipmentUserDataField field="registration" label="CPF/CNPJ" />
      <DateField source="shipmentDate" label="Data da Remessa" />
      <TextField source="trackingCode" label="Código de Rastreamento" />
      <TextField source="plugNumber" label="Número do Plug" />
      <ReferenceField
        source="productId"
        reference="products"
        label="Produto"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        source="licenseId"
        reference="licenses"
        label="Código do Serial"
      >
        <TextField source="serialNumber" />
      </ReferenceField>
      <DateField source="receiptDate" label="Data de Recebimento" emptyText="Não recebida" />
      <DateField source="createdAt" label="Criado em" showTime />
    </Datagrid>
  </List>
);
